/* unplugin-vue-components disabled */
export default {
  props: {
    title: {type: String, default: undefined},
    icon: {type: String, default: 'upload-02'},
    accept: {type: String, default: '.jpg,.jpeg,.png'},
    fileSize: {type: Number, default: 5 * 1024 * 1024},
  },
  emits: ['upload'],
  methods: {
    async pickFile() {
      const file = await new Promise((resolve) => {
        const input = document.createElement('input')
        input.type = 'file'
        input.accept = this.accept
        input.value = ''
        input.style.display = 'none'

        input.onchange = () => {
          const file = input.files?.[0] || null

          if (!file)  return resolve(null)
          
          if (file.size > this.fileSize) {
            $utils.toasts.error(`Please select a file smaller than ${$utils.format.bytes(this.fileSize)}.`)
            input.remove()
            return resolve(null)
          }

          input.remove()
          resolve(file)
        }
    
        document.body.appendChild(input)
        input.click()
      })
  
      if (file) this.$emit('upload', file)
    },
  }
}
